<template>
    <section class="form-section">
        <div class="form-section__head">
            <h2 class="form-section__title">Productos</h2>
            <div class="form-section__action">
                <span class="form-section__counter">
                    {{ productCart.length }} {{ productCart.length === 1 ? 'producto' : 'productos' }}
                </span>
                <v-btn small depressed color="primary" class="nv-cart__add" @click.prevent="addCartProduct()"
                title="Añadir producto (F2)" aria-label="Añadir producto">
                    <v-icon x-small left>fas fa-plus-square</v-icon>
                    Añadir producto (F2)
                </v-btn>
            </div>
        </div>

        <v-simple-table dense class="nv-cart">
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">Producto</th>
                        <th class="text-left" v-if="modeProcess">Nuevo producto</th>
                        <th class="text-right">Cantidad (PZA)</th>
                        <th class="text-right" v-if="modeProcess">Cantidad (KG aprox)</th>
                        <th class="text-right" v-else>Cantidad (KG)</th>
                        <th class="text-left" v-if="modeProcess">Unidad salida</th>
                        <th class="text-center" v-if="modeProcess">Cambiar unidad</th>
                        <th class="text-left" v-else>Unidad venta</th>
                        <th class="text-right">Precio</th>
                        <th class="text-right">Importe</th>
                        <th class="text-center nv-cart__th-action">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in productCart" :key="item.id" class="nv-cart__row">
                        <td class="nv-cart__cell nv-cart__cell--wide" data-label="Producto">
                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                <v-autocomplete class="nv-cart__input" :items="products" item-text="nombre" item-value="id"
                                filled outlined dense hide-details="auto" required
                                @change="(e) => changeProduct(e, index)"
                                :value="item.productoId" :error-messages="errors" :success="valid">
                                </v-autocomplete>
                            </ValidationProvider>
                        </td>

                        <td class="nv-cart__cell nv-cart__cell--wide" v-if="modeProcess" data-label="Nuevo producto">
                            <ValidationProvider rules="required" v-slot="{ errors, valid}" :immediate="true">
                                <v-autocomplete class="nv-cart__input" :items="productsProcess" item-text="nombre" item-value="id"
                                :item-disabled="(p) => p.id === item.productoId"
                                filled outlined dense hide-details="auto" required
                                @change="(e) => changeNewProduct(e, index)"
                                :value="item.newProductId" :error-messages="errors" :success="valid">
                                </v-autocomplete>
                            </ValidationProvider>
                        </td>

                        <td class="nv-cart__cell nv-cart__cell--num" data-label="Cantidad (PZA)">
                            <ValidationProvider
                            :rules="item.isServicio
                            ? 'required|decimal|min_value:0.5|step:0.5'
                            : `required|decimal|min_value:0.5|max_value:${item.stock}|step:0.5`"
                            v-slot="{ errors, valid }" :immediate="true">
                                <v-text-field v-model="item.cantidad" type="number" class="nv-cart__input nv-cart__num"
                                filled outlined dense hide-details="auto" required min="1" :max="item.stock" placeholder="0.00"
                                @input="(e) => changeItem(e, index, 'cantidad')"
                                :error-messages="errors" :success="valid">
                                </v-text-field>
                            </ValidationProvider>
                        </td>

                        <td class="nv-cart__cell nv-cart__cell--num" :data-label="modeProcess ? 'Cantidad (KG aprox)' : 'Cantidad (KG)'">
                            <ValidationProvider
                            :rules="item.isServicio
                            ? (item.unitOutName === 'Pieza' ? '' : 'required|decimal|min_value:0.1')
                            : 'required|decimal|min_value:0.5'"
                            v-slot="{ errors, valid }" :immediate="true">
                                <v-text-field v-model="item.kg" type="number" placeholder="0.00"
                                class="nv-cart__input nv-cart__num" filled outlined dense hide-details="auto"
                                @input="(e) => changeItemKg(e, index, 'kg')"
                                required min="0.5" :error-messages="errors" :success="valid"
                                :disabled="modeProcess">
                                </v-text-field>
                            </ValidationProvider>
                        </td>

                        <td class="nv-cart__cell" v-if="modeProcess" data-label="Unidad salida">
                            <v-switch v-model="item.unitOutName" class="nv-cart__switch"
                            :true-value="item.unitOutName" :false-value="getOppositeUnit(item.unitOutName)"
                            :label="`${item.unitOutName}`" dense hide-details
                            @change="(e) => changeUnitOut(e, index , 'unitOutName')">
                            </v-switch>
                        </td>

                        <td class="nv-cart__cell" :data-label="modeProcess ? 'Cambiar unidad' : 'Unidad venta'">
                            <span class="nv-cart__unit">{{ item.nameUnit }}</span>
                        </td>

                        <td class="nv-cart__cell nv-cart__cell--num" data-label="Precio">
                            <!-- El precio solo se edita para el cliente 30 y nunca para un servicio. -->
                            <ValidationProvider v-if="venta.clienteId == 30"
                            :rules="item.isServicio ? '' : `required|decimal|min_value:${item.minPrice}`"
                            v-slot="{ errors, valid }" :immediate="true">
                                <v-text-field v-model="item.precioVenta" type="number" placeholder="0.00"
                                class="nv-cart__input nv-cart__num" filled outlined dense hide-details="auto" prefix="$"
                                @input="(e) => changePrice(e, index, 'precioVenta')"
                                required min="0.5" :error-messages="errors" :success="valid"
                                :disabled="item.isServicio">
                                </v-text-field>
                            </ValidationProvider>
                            <span v-else class="nv-cart__money">{{ formatMoney(item.precioVenta) }}</span>
                        </td>

                        <td class="nv-cart__cell nv-cart__cell--num" data-label="Importe">
                            <span class="nv-cart__money nv-cart__money--total">{{ formatMoney(item.total) }}</span>
                        </td>

                        <td class="nv-cart__cell nv-cart__cell--action">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small class="nv-cart__delete" v-bind="attrs" v-on="on"
                                    :aria-label="`Quitar ${item.producto || 'producto'}`"
                                    @click.prevent="deleteProduct(item, index)">
                                        <v-icon small>fas fa-trash-alt</v-icon>
                                    </v-btn>
                                </template>
                                <span>Quitar producto</span>
                            </v-tooltip>
                        </td>
                    </tr>
                </tbody>
                <!-- La regla de cálculo viaja con la tabla, no en una banda
                     aparte por encima: la nota ocupaba 26px de alto que no
                     eran tabla. Aquí sigue visible y no empuja la tabla. -->
                <tfoot>
                    <tr>
                        <td colspan="9" class="nv-cart__note-cell">
                            <div class="nv-cart__note">
                                <v-icon x-small class="nv-cart__note-icon">fas fa-info-circle</v-icon>
                                <span v-if="modeInternalSell">
                                    Venta interna: la unidad de salida es el kilogramo, el importe es kg × precio.
                                </span>
                                <span v-else>
                                    Unidad PZA: importe = cantidad × precio. Unidad KG: importe = kilogramos × precio.
                                </span>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </template>
        </v-simple-table>
    </section>
</template>

<script>
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import EntradaDetalleDataService from '@/service/entrada/EntradaDetalleDataService';
import ProductoDataService from '@/service/producto/ProductoDataService';
import { escapeHtml } from '@/helpers/swalHelper';
import { getFormatCurrency, toNumber } from '@/utils/CurrencyUtil';

export default {
    name: "addSellProduct",
    props: {
        venta: { type: Object, default: () => ({}) },
        products: {},
        listEntradaDetalle: { type: Array, default: () => [] },
    },
    mounted() {
        document.addEventListener('keydown', this.addListenerProduct);
    },
    destroyed() {
        document.removeEventListener('keydown', this.addListenerProduct);
    },
    data() {
        return {
            productCart: [],
            detailProduct: [],
            productSelectedId: 0,
            detailProductRequestId: 0,
            productsProcess: [],
        }
    },
    methods: {
        formatMoney(value) {
            return getFormatCurrency(toNumber(value, 0), '$');
        },
        generateCartProduct() {
            return {
                id: null,
                ventaId: null,
                productoListaPrecioId: null,
                productoId: null,
                newProductId: null,
                producto: '',
                unidad: '',
                // modeInternalSell
                unidadSalidaId: null,
                cantidad: 0,
                kg: 0,
                stock: 0,
                precioVenta: 0,
                total: 0,
                isServicio: false,
            }
        },
        addCartProduct() {
            if(this.productCart.length > 0){
                const hasProductEmpty = this.productCart.find(x => x.productoId == null );
                if(hasProductEmpty){
                    this.$swal.fire({ position : 'top-end', icon: 'info', text: 'Ya existe un producto vacio en la lista', showConfirmButton: false, timer: 2000 });
                    return;
                }
            }
            this.productCart.push(this.generateCartProduct());
        },
        addListenerProduct(e) {
            if (e.keyCode === 174) {
                this.addCartProduct();
            }
        },
        deleteProduct(cartElement, index){
            this.enableProduct(cartElement.productoId, cartElement);
            this.productCart.splice(index, 1);
        },
        enableProduct(productSelected, cartElement){
            const indexProduct = this.products.findIndex(x => x.id == productSelected);
            const indexPrevProduct = this.products.findIndex(x => x.id == cartElement.productoId);
            if(indexProduct > -1){
                this.products[indexProduct].disabled = true;
            }
            if(indexPrevProduct > -1) {
                this.products[indexPrevProduct].disabled = false;
            }
        },
        reEnableAllProducts() {
            this.products.forEach(product => product.disabled = false);
        },
        changeProduct(e, index){
            if( e != null && e > 0 ) {
                const prevProduct = this.productCart[index];
                this.enableProduct(e, prevProduct);
                this.productCart[index].productoId = e;
                this.productSelectedId = e;
                const product = this.products.find(prod => prod.id == e);

                this.productCart[index].cantidad = 1;
                this.productCart[index].kg = 0;
                this.productCart[index].precioVenta = product.precioVenta || 0;
                this.productCart[index].minPrice = product.minPrice || 0;
                this.productCart[index].productoListaPrecioId = product.listaPrecioId;
                this.productCart[index].producto = product.nombre;
                this.productCart[index].unidad = product.tipoUnidad.clave;
                this.productCart[index].nameUnit = product.tipoUnidad.nombre;
                // Start: It was added only to the case modeInternalSell
                this.productCart[index].unidadSalidaId = product.tipoUnidad.id;
                this.productCart[index].unitOutName = product.tipoUnidad.nombre;
                // End
                this.productCart[index].isServicio = product.isServicio;
                this.productCart[index].total = this.getTotal(this.productCart[index]);
            }
        },
        changeNewProduct(e, index){
            if( e != null && e > 0 ) {
                const prevProduct = this.productCart[index].productoId;
                this.productCart[index].newProductId = e;
                this.productCart[index].kg = this.detailProduct.filter(prod => prod.productoId == prevProduct)[0].averageWeight || 0;
            }
        },
        async getDetailsProduct( productId ){
            const sucursalId = SucursalDataService.getCurrentSucursalId();
            const requestId = ++this.detailProductRequestId;
            await EntradaDetalleDataService.getEntradaDetalleProductoSucursal( productId, sucursalId).then( resp => {
                // Se descarta la respuesta si el productoSelectedId ya cambio (respuesta obsoleta).
                if( requestId !== this.detailProductRequestId ){
                    return;
                }
                this.detailProduct = resp.data || [];
                this.$emit('getDetailProduct', this.detailProduct);
                this.validateStock( productId );
            });
        },
        // Here is the function that calculates the total
        getTotal(oneProductCart){
            const unity = oneProductCart.unidad;
            const precio = parseFloat(oneProductCart.precioVenta || 0);
            let total;
            if (this.modeInternalSell) {
                total = oneProductCart.kg * precio;
            } else {
                total = (unity === 'KG') ? (oneProductCart.kg * precio) : (oneProductCart.cantidad * precio);
            }
            // Round up to nearest 0.5
            return Math.ceil(total * 2) / 2;

            // return parseFloat(total.toFixed(2));
            // return parseFloat(total).toFixed(2);
        },
        changeItem(e, index, field){
            if(e == null || e <= 0) return;
            const item = this.productCart[index];
            // TODO: This is a special case but it should be refactored and put this logic in the product.
            const isPolloFresco = item.productoId == 2 ;
            item[field] = e;
            const productDetails = this.detailProduct.filter( x => x.productoId == item.productoId )[0];
            const averageWeight = productDetails?.averageWeight ?? 0;

            if (item.newProductId && item.newProductId > 0 || (!this.modeInternalSell && !isPolloFresco) || this.modeMovement ) {
               item.kg = parseFloat( averageWeight * item.cantidad ).toFixed(2);
            }
            if(this.modeInternalSell){
                item.unidadSalidaId = 2;
                item.unitOutName = 'KG';
            }
            item.total = this.getTotal(item);
            this.productCart[index] = item;
        },
        changeItemKg(e, index, field){
            if(e == null || e <= 0) return;
            const item = this.productCart[index];
            item[field] = e;
            if(this.modeInternalSell){
                item.unidadSalidaId = 2;
                item.unitOutName = 'KG';
            }
            item.total = this.getTotal(item);
            this.productCart[index] = item;
        },
        getOppositeUnit(unit){
            return unit == 'PZA' ? 'KG' : 'PZA';
        },
        changeUnitOut(e, index, field){
            const product = this.productCart[index];
            product[field] = e;
            product.unidadSalidaId = e == 'PZA' ? 1 : 2;
            product.unidad = e == 'PZA' ? 'PZA' : 'KG';
            product.nameUnit = e == 'PZA' ? 'Pieza' : 'Kilogramo';
            product.total = this.getTotal(product);
            this.productCart[index] = product;
        },
        changePrice(e, index, field){
            if(e == null || e <= 0) return;
            const item = this.productCart[index];
            item[field] = e;
            item.total = this.getTotal(item);
            this.productCart[index] = item;
        },
        validateStock( productSelectedId ){
            const indexProduct = this.products.findIndex(x => x.id == productSelectedId );
            const indexProductCart = this.productCart.findIndex(x => x.productoId == productSelectedId );
            const itemProduct = this.products.find(x => x.id == productSelectedId );
            if( indexProductCart < 0 || !this.productCart[indexProductCart] ){
                // El producto ya fue eliminado del carrito: no hay nada que validar.
                return;
            }
            if(this.productCart[indexProductCart].isServicio){
                return;
            }
            if( this.detailProduct == undefined || this.detailProduct.length == 0 ){
                this.$swal.fire({ position: 'top-right', icon: 'warning', title: 'Existencias',
                html: `<strong>${escapeHtml(itemProduct?.nombre?.toUpperCase() || '')}</strong> sin existencia en la sucursal`, showConfirmButton: false, timer: 3500 });
                if( indexProduct > -1 ){
                    this.products[indexProduct].disabled = false;
                }
                this.productCart[indexProductCart].productoId = null;
                this.productCart[indexProductCart].stock = 0;
            } else {
                const productStock = this.detailProduct.filter( x => x.productoId == productSelectedId )
                .reduce( (total, item) => total + item.existencia, 0 );
                this.productCart[indexProductCart].stock = productStock;
                if( productStock <= 0 && indexProduct > -1 ){
                    this.products[indexProduct].disabled = false;
                }
            }

        },
        emitAddCartProduct(data){
            // El total de la venta lo calcula la vista padre; aquí solo se publica el carrito.
            this.$emit('addProductCart', data);
        },
        async getAllProduct(){
            this.productsProcess = await ProductoDataService.findAll().then( resp => {
                return resp.data.filter( x => x.hasProcess )
            }) || []
        },
    },
    watch: {
        productCart: {
            handler(newValue) {
                this.emitAddCartProduct(newValue);
            },
            deep: true
        },
        productSelectedId(newValue){
            if( newValue != null && newValue > 0 ) {
                this.reEnableAllProducts();
                if( this.modeSell ){
                    this.getDetailsProduct( newValue );
                    this.productSelectedId = 0;
                } else {
                    const lstDetailProduct = this.listEntradaDetalle.find( entry => entry.id == this.venta.entradaDetalleId );
                    this.detailProduct = lstDetailProduct ? [lstDetailProduct] : [];
                    this.$emit('getDetailProduct', this.detailProduct);
                    this.validateStock( newValue );
                    this.productSelectedId = 0;
                }
            }
        },
        'venta.entradaDetalleId': function( newValue ){
            if( newValue != null && newValue > 0 && this.productCart.length > 0 ) {
                const lstDetailProduct = this.listEntradaDetalle.find( entry => entry.id == newValue );
                this.detailProduct = lstDetailProduct ? [lstDetailProduct] : [];
                this.$emit('getDetailProduct', this.detailProduct);
                this.validateStock( newValue );
                this.productSelectedId = 0;
            }
        },
        'venta.tipoSalidaId': function( newValue ){
            this.productSelectedId = 0;
            if(newValue != null && newValue > 0 && newValue == 4 && this.productsProcess.length == 0){
                this.getAllProduct();
            }
        }
    },
    computed: {
        modeSell() { return this.venta.tipoSalidaId == 1 || this.venta.tipoSalidaId == 5; },
        modeMovement() { return this.venta.tipoSalidaId == 2 || this.venta.tipoSalidaId == 3; },
        modeTraspaso() { return this.venta.tipoSalidaId == 3; },
        modeMerma() { return this.venta.tipoSalidaId == 2; },
        modeProcess() { return this.venta.tipoSalidaId == 4; },
        modeInternalSell() { return this.venta.tipoSalidaId == 5; }
    }
}
</script>

<style scoped>
    /* Tabla de carrito: encabezado claro, celdas con un único estilo de campo.
       El total NO se repite aquí: vive en el pie fijo de la vista. */
    .nv-cart {
        margin-top: 8px;
        border-top: 1px solid var(--app-line);
    }
    /* Encabezado con el tinte primary al 8%: hace juego con la barra y los
       acentos de la vista en vez de un gris suelto. */
    .nv-cart ::v-deep thead th {
        background: color-mix(in srgb, var(--app-primary) 8%, transparent);
        color: var(--app-primary);
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0;
        padding: 10px 8px;
        white-space: nowrap;
        border-bottom: 1px solid color-mix(in srgb, var(--app-primary) 20%, transparent);
    }
    .nv-cart ::v-deep thead th:first-child { border-top-left-radius: 6px; }
    .nv-cart ::v-deep thead th:last-child { border-top-right-radius: 6px; }
    /* Aire vertical entre filas: las celdas ya no se pegan unas a otras. */
    .nv-cart ::v-deep tbody td {
        padding: 10px 8px;
        border-bottom: 1px solid var(--app-line);
        vertical-align: middle;
    }
    .nv-cart ::v-deep tbody tr:hover {
        background: color-mix(in srgb, var(--app-primary) 4%, transparent);
    }
    .nv-cart__th-action { width: 56px; padding-left: 4px !important; padding-right: 4px !important; }
    .nv-cart__cell--action { padding-left: 4px !important; padding-right: 4px !important; }

    .nv-cart__cell { min-width: 0; }
    /* El select del producto necesita aire para leer el nombre completo. */
    @media (min-width: 600px) {
        .nv-cart__cell--wide { min-width: 130px; }
    }
    .nv-cart__cell--num { text-align: right; }
    .nv-cart__cell--action { text-align: center; }

    /* Un solo estilo de campo en toda la fila: filled outlined dense. El
       borde (`outlined`) hace visible el campo sobre el fondo blanco de la
       tarjeta; el alto baja a 36px y el padding lateral a 6px, porque un
       select con 8px + flecha + 8px se comía la celda. */
    .nv-cart__input ::v-deep .v-input__slot {
        min-height: 36px !important;
        padding: 0 6px;
        background: var(--app-surface-sunken);
    }
    .nv-cart__input ::v-deep .v-input__control {
        min-height: 36px;
    }
    .nv-cart__input ::v-deep input {
        font-size: 14px;
        font-weight: 500;
        padding: 6px 0;
    }
    .nv-cart__input ::v-deep .v-input__append-inner {
        margin-top: 6px;
    }
    .nv-cart__input ::v-deep .v-input__append-inner .v-icon {
        font-size: 16px;
    }
    .nv-cart__input ::v-deep .v-messages {
        text-align: left;
    }

    /* Números alineados a la derecha con cifras tabulares: se comparan de un vistazo. */
    .nv-cart__num ::v-deep input {
        text-align: right;
        font-variant-numeric: tabular-nums;
    }

    .nv-cart__switch {
        margin-top: 0;
    }
    .nv-cart__switch ::v-deep .v-messages { display: none; }

    .nv-cart__unit {
        display: block;
        font-size: 13px;
        color: var(--app-text-muted);
        padding-left: 2px;
        white-space: nowrap;
    }

    .nv-cart__money {
        display: block;
        font-size: 14px;
        font-weight: 600;
        color: var(--app-text);
        font-variant-numeric: tabular-nums;
        padding-right: 2px;
        white-space: nowrap;
    }
    .nv-cart__money--total {
        font-weight: 700;
        color: var(--app-success-ink);
    }

    .nv-cart__delete {
        color: var(--app-danger-ink) !important;
    }

    /* "Añadir producto" vive en el encabezado de la sección, con el color
       primary: es la acción principal de la tabla. 28px de alto caben en la
       caja de 30px del encabezado. */
    .nv-cart__add.v-btn {
        height: 28px;
        padding: 0 12px;
        letter-spacing: 0;
        text-transform: none;
        font-weight: 600;
    }

    /* La regla de cálculo es una nota informativa: 12px, icono de info y un
       tinte `info` al 7%, para que se lea como ayuda y no como dato. */
    .nv-cart__note-cell {
        padding: 12px 0 8px !important;
        border-bottom: 0 !important;
    }
    .nv-cart__note {
        display: flex;
        align-items: flex-start;
        gap: 8px;
        padding: 8px 10px;
        border-radius: 4px;
        background: color-mix(in srgb, var(--app-info) 7%, transparent);
        font-size: 12px;
        line-height: 16px;
        color: var(--app-text-muted);
    }
    .nv-cart__note-icon {
        margin-top: 2px;
        color: var(--app-info) !important;
    }

    /* Móvil: una tabla de 9 columnas no cabe en 375px. Cada fila del carrito se
       vuelve una tarjeta: el producto ocupa todo el ancho y el resto de las
       celdas se acomodan en una rejilla de dos columnas, con su etiqueta
       (`data-label`) encima del valor. Solo CSS: la tabla, los
       ValidationProvider y los campos siguen siendo los mismos. */
    @media (max-width: 599px) {
        .nv-cart ::v-deep table,
        .nv-cart ::v-deep tbody,
        .nv-cart ::v-deep tfoot,
        .nv-cart ::v-deep tfoot tr,
        .nv-cart ::v-deep tfoot td { display: block; width: 100%; }
        .nv-cart ::v-deep thead { display: none; }
        /* `v-data-table--dense` fija cada `td` en 32px; con `display: block`
           eso recorta el contenido y los mensajes de error se montan sobre
           la etiqueta siguiente. */
        .nv-cart ::v-deep td { height: auto !important; }
        .nv-cart ::v-deep tr.nv-cart__row > td > span { display: block; }

        .nv-cart ::v-deep tr.nv-cart__row {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px 8px;
            position: relative;
            padding: 12px 8px;
            border-bottom: 1px solid var(--app-line);
        }
        .nv-cart ::v-deep tr.nv-cart__row:hover { background: transparent; }
        .nv-cart ::v-deep tr.nv-cart__row > td {
            display: block;
            padding: 0;
            border: 0;
            text-align: left;
            min-width: 0;
        }
        .nv-cart ::v-deep tr.nv-cart__row > td::before {
            content: attr(data-label);
            display: block;
            margin-bottom: 2px;
            font-size: 12px;
            font-weight: 700;
            color: var(--app-text-muted);
        }
        .nv-cart ::v-deep tr.nv-cart__row > td.nv-cart__cell--wide { grid-column: 1 / -1; }
        .nv-cart ::v-deep tr.nv-cart__row > td.nv-cart__cell--num { text-align: left; }
        .nv-cart ::v-deep tr.nv-cart__row > td.nv-cart__cell--num .nv-cart__num input { text-align: left; }
        .nv-cart ::v-deep tr.nv-cart__row > td.nv-cart__cell--action {
            grid-column: 1 / -1;
            text-align: right;
        }
        .nv-cart ::v-deep tr.nv-cart__row > td.nv-cart__cell--action::before { display: none; }
    }
</style>
